import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import TodoList from "@/components/Todos/TodoList.vue";
import AppBar from "@/components/AppBar.vue";
import { namespace } from "vuex-class";
const todos = namespace('Todos/');
let MyTodos = class MyTodos extends Vue {
    myTodos;
    getMyTodos;
    hasMoreMyTodos;
    isLoadingMyTodoData;
    async mounted() {
        if (this.myTodos.length == 0) {
            this.loadMoreTodos();
        }
    }
    async loadMoreTodos() {
        await this.getMyTodos();
    }
};
__decorate([
    todos.State
], MyTodos.prototype, "myTodos", void 0);
__decorate([
    todos.Action
], MyTodos.prototype, "getMyTodos", void 0);
__decorate([
    todos.State
], MyTodos.prototype, "hasMoreMyTodos", void 0);
__decorate([
    todos.State
], MyTodos.prototype, "isLoadingMyTodoData", void 0);
MyTodos = __decorate([
    Component({
        components: {
            TodoList,
            AppBar
        },
    })
], MyTodos);
export default MyTodos;
